import { formatDateToISO } from "../Admin/TransferIds/TransferIdTable/utils";

export const sortByTransferId = (a: any, b: any): number => {
  const numA = parseInt(a.transfer_id.split("-")[0], 10);
  const numB = parseInt(b.transfer_id.split("-")[0], 10);
  return numA - numB;
};

export const filterByDate = (value: any, recordDateField: string): boolean => {
  const isoValue = formatDateToISO(value);
  const recordDate = new Date(recordDateField).toISOString().split("T")[0];
  return recordDate === isoValue;
};

export const sortByDate = (a: any, b: any, dataIndex: string, ascending: boolean = true): number => {
  return (ascending ? 1 : -1) * (new Date(a[dataIndex]).getTime() - new Date(b[dataIndex]).getTime());
};

export const sortByUpdatedBy = (a: any, b: any, field: string): number => {
  const aVal = a[field] ? String(a[field]) : "";
  const bVal = b[field] ? String(b[field]) : "";
  return aVal.localeCompare(bVal);
};
